import { normalizeLatexMathDelimiters } from "@/components/content/markdown-math";

function removeDuplicateGovernedSourceSections(content: string): string {
  const lines = content.split("\n");
  const governedHeadings = lines.flatMap((line, index) =>
    /^(?:#{1,6}[ \t]+governed[ \t]+sources|\*\*[ \t]*governed[ \t]+sources[ \t]*\*\*)[ \t]*:?$/iu.test(
      line,
    )
      ? [index]
      : [],
  );
  if (governedHeadings.length <= 1) return content;

  const removedLines = new Set<number>();
  for (const start of governedHeadings.slice(0, -1)) {
    let end = start + 1;
    while (end < lines.length && !/^#{1,6}[ \t]+/u.test(lines[end] ?? "")) {
      end += 1;
    }
    for (let index = start; index < end; index += 1) {
      removedLines.add(index);
    }
  }
  return lines.filter((_, index) => !removedLines.has(index)).join("\n");
}

export function normalizeMarkdownContent(
  content: string,
  options?: { streaming?: boolean },
): string {
  const stripped = content
    .replace(/\r\n/g, "\n")
    .replace(/(?:\u200B|\u200C|\u200D|\uFEFF)/g, "");
  // Deleting an earlier duplicate section mid-stream rewrites text the reader
  // has already seen; dedup only once the response is final.
  return normalizeLatexMathDelimiters(
    options?.streaming ? stripped : removeDuplicateGovernedSourceSections(stripped),
  )
    .replace(/[ \t]+\n/g, (trailingWhitespace: string) =>
      / {2,}\n$/.test(trailingWhitespace) ? "  \n" : "\n")
    .replace(/\n(?:[ \t\u00A0]*\n)+/g, "\n\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
